module.exports = __webpack_public_path__ + "assets/img/filter.2c22840b.svg";